"use strict";
/**
 * Do not edit directly
 * Generated on Fri, 17 Mar 2023 04:59:02 GMT
 */
exports.__esModule = true;
exports.IconXxl = exports.IconXl = exports.IconL = exports.IconM = exports.IconS = exports.IconXs = void 0;
exports.IconXs = "16px";
exports.IconS = "18px";
exports.IconM = "24px";
exports.IconL = "28px";
exports.IconXl = "32px";
exports.IconXxl = "48px";
